'use client';

import { useState } from 'react';
import { Button, type buttonVariants } from '@/components/ui/button';
import { DownloadModal } from '@/components/download-modal';
import { useDownloadAction } from '@/lib/use-download-action';
import type { VariantProps } from 'class-variance-authority';

interface DownloadButtonProps
  extends React.ComponentProps<typeof Button>,
    VariantProps<typeof buttonVariants> {
  children: React.ReactNode;
}

export function DownloadButton({ children, ...props }: DownloadButtonProps) {
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const { handleDownload } = useDownloadAction();

  return (
    <>
      <Button
        {...props}
        onClick={() => handleDownload(() => setShowDownloadModal(true))}
      >
        {children}
      </Button>
      <DownloadModal open={showDownloadModal} onOpenChange={setShowDownloadModal} />
    </>
  );
}
